import React from "react";
import { Link } from "react-router-dom";

/**
 * Brand wordmark used consistently in Navbar, MobileMenu and Footer.
 * variant: "dark" (default — for light backgrounds) | "light" (for dark backgrounds)
 * size: "sm" | "md" | "lg"
 */
export default function BrandLogo({
  variant = "dark",
  size = "md",
  asLink = true,
  className = "",
  testid = "brand-logo",
}) {
  const sizeMap = {
    sm: { across: "text-lg", indo: "text-xl" },
    md: { across: "text-xl", indo: "text-2xl" },
    lg: { across: "text-2xl", indo: "text-3xl" },
  };
  const s = sizeMap[size] || sizeMap.md;

  const colorClass =
    variant === "light"
      ? "text-white"
      : "text-slate-900";

  const inner = (
    <span
      data-testid={testid}
      className={`inline-flex items-baseline gap-2 ${colorClass} ${className}`}
    >
      <span className={`${s.across} font-light tracking-tight`}>Across</span>
      <span className={`font-script ${s.indo} font-bold tracking-tight leading-none`}>
        Indonesia
      </span>
    </span>
  );

  if (!asLink) return inner;
  return (
    <Link to="/" className="inline-flex">
      {inner}
    </Link>
  );
}
